import React from 'react';
import {  Link } from 'react-router';
import { FormattedMessage } from 'react-intl';

export default class PreviewCounterActivatedEntities extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            firstNumber:  0,
            secondNumber: props.previewEntitiesCount
        };

    }

    componentWillReceiveProps(nextProps) {

        if (this.props.previewEntitiesCount > nextProps.previewEntitiesCount) {

            let firstNumber = this.state.firstNumber;
            firstNumber++;

            this.setState({
                firstNumber:  firstNumber,
                secondNumber: nextProps.previewEntitiesCount
            });
            return;
        }

        this.setState({
            secondNumber: nextProps.previewEntitiesCount
        });

    }

    render() {

        return (
            <div className="preview-navigation no-print">

                <div className="preview-navigation__activateAndShowNext">
                    <button className="button-primary-sm preview" onClick={this.props.activateAndShowNextCompany}>
                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.activateAndShowCompany" />
                    </button>
                </div>

                <div className='navigation-container'>
                    <div className="preview-navigation__backToReview">
                        <span className="backToReview-arrow"></span>
                        <Link to="/review-companies">
                            <FormattedMessage id="Entities_Preview_UIText_previewCompanies.backToReview" />
                        </Link>
                    </div>

                    <span className="preview-navigation__entities-activated">
                    <span>{this.state.firstNumber}</span>
                        &nbsp;
                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.resultsCounter.of" />
                        &nbsp;
                        <span>{this.state.firstNumber + this.state.secondNumber}</span>
                        &nbsp;
                        <FormattedMessage id="Entities_Preview_UIText_previewCompanies.resultsCounter.entitiesActivated" />
                    </span>
                </div>

            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/PreviewCompany/template/PreviewCompany.previewCounterActivatedEntities.jsx